import './DeleteButton.css';
import { API_BASE, authHeaders } from '../utils/Utils.js';

export const DeleteButton = (props) => {

  const deleteByID = (id) => {
    const baseCollection = props.collection.split('?')[0];
    const url = `${API_BASE}/api/data/${baseCollection}/${id}`;
    fetch(url, {
      method: 'DELETE',
      headers: authHeaders({ "Content-Type": "application/json" }),
    })
    .then(response => {
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('zapmanejo_token');
          localStorage.removeItem('zapmanejo_user');
          window.location.reload();
        }
        return response.text().then(text => {
          throw new Error(text || `HTTP error! status: ${response.status}`);
        });
      }
      props.onComplete();
    })
    .catch(error => {
      console.error('Error deleting data:', error);
      if (props.onError) {
        props.onError(error.message);
      }
    });
  }

  const handleDelete = (e) => {
    props.data.forEach(row => {
      deleteByID(row._id);
    });
  }

  if (props.data === null) return;
  if (props.data === undefined) return;
  if (!Array.isArray(props.data)) return;
  const count = props.data.length;
  if (count === 0) return;

  let text = `Delete ${count} item`;
  if (count > 1) {
    text += "s"
  }
  return (
    <button className="deleteButton" onClick={handleDelete}>
      <span className="delete-text">{text}</span>
      <span className="delete-mobile-text">Delete</span>
    </button>
  );
}

export default DeleteButton;
